import { useRef as cn } from "react";
const Ue = /* @__PURE__ */ new Set();
function Pe(t, e, n) {
  t || Ue.has(e) || (console.warn(e), Ue.add(e));
}
function fn(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
const dn = (t) => Array.isArray(t);
function hn(t) {
  return typeof t == "string" || Array.isArray(t);
}
function Ge(t) {
  const e = [{}, {}];
  return t == null || t.values.forEach((n, s) => {
    e[0][s] = n.get(), e[1][s] = n.getVelocity();
  }), e;
}
function mt(t, e, n, s) {
  if (typeof e == "function") {
    const [i, r] = Ge(s);
    e = e(n !== void 0 ? n : t.custom, i, r);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [i, r] = Ge(s);
    e = e(n !== void 0 ? n : t.custom, i, r);
  }
  return e;
}
function pn(t, e, n) {
  const s = t.getProps();
  return mt(s, e, n !== void 0 ? n : s.custom, t);
}
const mn = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], gn = ["initial", ...mn], B = (t) => t;
let Z = B, U = B;
process.env.NODE_ENV !== "production" && (Z = (t, e) => {
  !t && typeof console < "u" && console.warn(e);
}, U = (t, e) => {
  if (!t)
    throw new Error(e);
});
function Ce(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const Fe = (t, e, n) => {
  const s = e - t;
  return s === 0 ? 1 : (n - t) / s;
}, R = (t) => t * 1e3, I = (t) => t / 1e3, yn = Ce(() => window.ScrollTimeline !== void 0);
class vn {
  constructor(e) {
    this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((e) => "finished" in e ? e.finished : e));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, n) {
    for (let s = 0; s < this.animations.length; s++)
      this.animations[s][e] = n;
  }
  attachTimeline(e, n) {
    const s = this.animations.map((i) => yn() && i.attachTimeline ? i.attachTimeline(e) : n(i));
    return () => {
      s.forEach((i, r) => {
        i && i(), this.animations[r].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let e = 0;
    for (let n = 0; n < this.animations.length; n++)
      e = Math.max(e, this.animations[n].duration);
    return e;
  }
  runAll(e) {
    this.animations.forEach((n) => n[e]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
class bn extends vn {
  then(e, n) {
    return Promise.all(this.animations).then(e).catch(n);
  }
}
function gt(t, e) {
  return t ? t[e] || t.default || t : void 0;
}
const ge = 2e4;
function yt(t) {
  let e = 0;
  const n = 50;
  let s = t.next(e);
  for (; !s.done && e < ge; )
    e += n, s = t.next(e);
  return e >= ge ? 1 / 0 : e;
}
function De(t) {
  return typeof t == "function";
}
function je(t, e) {
  t.timeline = e, t.onfinish = null;
}
const Re = (t) => Array.isArray(t) && typeof t[0] == "number", Tn = {
  linearEasing: void 0
};
function Vn(t, e) {
  const n = Ce(t);
  return () => {
    var s;
    return (s = Tn[e]) !== null && s !== void 0 ? s : n();
  };
}
const ie = /* @__PURE__ */ Vn(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), vt = (t, e, n = 10) => {
  let s = "";
  const i = Math.max(Math.round(e / n), 2);
  for (let r = 0; r < i; r++)
    s += t(Fe(0, i - 1, r)) + ", ";
  return `linear(${s.substring(0, s.length - 2)})`;
};
function bt(t) {
  return !!(typeof t == "function" && ie() || !t || typeof t == "string" && (t in ye || ie()) || Re(t) || Array.isArray(t) && t.every(bt));
}
const q = ([t, e, n, s]) => `cubic-bezier(${t}, ${e}, ${n}, ${s})`, ye = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ q([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ q([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ q([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ q([0.33, 1.53, 0.69, 0.99])
};
function Tt(t, e) {
  if (t)
    return typeof t == "function" && ie() ? vt(t, e) : Re(t) ? q(t) : Array.isArray(t) ? t.map((n) => Tt(n, e) || ye.easeOut) : ye[t];
}
function Li(t, e, n) {
  var s;
  if (t instanceof Element)
    return [t];
  if (typeof t == "string") {
    let i = document;
    e && (i = e.current);
    const r = (s = n == null ? void 0 : n[t]) !== null && s !== void 0 ? s : i.querySelectorAll(t);
    return r ? Array.from(r) : [];
  }
  return Array.from(t);
}
const Q = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], L = new Set(Q), $i = (t) => !!(t && typeof t == "object" && t.mix && t.toValue), wn = (t) => dn(t) ? t[t.length - 1] || 0 : t, Vt = {
  skipAnimations: !1,
  useManualTiming: !1
};
function xn(t) {
  let e = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), s = !1, i = !1;
  const r = /* @__PURE__ */ new WeakSet();
  let o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function a(u) {
    r.has(u) && (l.schedule(u), t()), u(o);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (u, c = !1, f = !1) => {
      const y = f && s ? e : n;
      return c && r.add(u), y.has(u) || y.add(u), u;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (u) => {
      n.delete(u), r.delete(u);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (u) => {
      if (o = u, s) {
        i = !0;
        return;
      }
      s = !0, [e, n] = [n, e], e.forEach(a), e.clear(), s = !1, i && (i = !1, l.process(u));
    }
  };
  return l;
}
const te = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], Sn = 40;
function An(t, e) {
  let n = !1, s = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, r = () => n = !0, o = te.reduce((p, x) => (p[x] = xn(r), p), {}), { read: a, resolveKeyframes: l, update: u, preRender: c, render: f, postRender: d } = o, y = () => {
    const p = performance.now();
    n = !1, i.delta = s ? 1e3 / 60 : Math.max(Math.min(p - i.timestamp, Sn), 1), i.timestamp = p, i.isProcessing = !0, a.process(i), l.process(i), u.process(i), c.process(i), f.process(i), d.process(i), i.isProcessing = !1, n && e && (s = !1, t(y));
  }, b = () => {
    n = !0, s = !0, i.isProcessing || t(y);
  };
  return { schedule: te.reduce((p, x) => {
    const M = o[x];
    return p[x] = (C, m = !1, w = !1) => (n || b(), M.schedule(C, m, w)), p;
  }, {}), cancel: (p) => {
    for (let x = 0; x < te.length; x++)
      o[te[x]].cancel(p);
  }, state: i, steps: o };
}
const { schedule: O, cancel: ve, state: re, steps: Wi } = An(typeof requestAnimationFrame < "u" ? requestAnimationFrame : B, !0);
let se;
function Mn() {
  se = void 0;
}
const N = {
  now: () => (se === void 0 && N.set(re.isProcessing || Vt.useManualTiming ? re.timestamp : performance.now()), se),
  set: (t) => {
    se = t, queueMicrotask(Mn);
  }
};
function Pn(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Cn(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
class wt {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return Pn(this.subscriptions, e), () => Cn(this.subscriptions, e);
  }
  notify(e, n, s) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](e, n, s);
      else
        for (let r = 0; r < i; r++) {
          const o = this.subscriptions[r];
          o && o(e, n, s);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function xt(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const ze = 30, Fn = (t) => !isNaN(parseFloat(t)), qe = {
  current: void 0
};
class Dn {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(e, n = {}) {
    this.version = "11.16.0", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (s, i = !0) => {
      const r = N.now();
      this.updatedAt !== r && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(s), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), i && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = n.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = N.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = Fn(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && Pe(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new wt());
    const s = this.events[e].add(n);
    return e === "change" ? () => {
      s(), O.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : s;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(e, n) : this.passiveEffect(e, this.updateAndNotify);
  }
  setWithVelocity(e, n, s) {
    this.set(n), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - s;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, n = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return qe.current && qe.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = N.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > ze)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, ze);
    return xt(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function oe(t, e) {
  return new Dn(t, e);
}
function Rn(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, oe(n));
}
function On(t, e) {
  const n = pn(t, e);
  let { transitionEnd: s = {}, transition: i = {}, ...r } = n || {};
  r = { ...r, ...s };
  for (const o in r) {
    const a = wn(r[o]);
    Rn(t, o, a);
  }
}
const P = (t) => !!(t && t.getVelocity);
function En(t) {
  return !!(P(t) && t.add);
}
function In(t, e) {
  const n = t.getValue("willChange");
  if (En(n))
    return n.add(e);
}
const Oe = (t) => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), Nn = "framerAppearId", Bn = "data-" + Oe(Nn);
function Kn(t) {
  return t.props[Bn];
}
const St = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, kn = 1e-7, _n = 12;
function Ln(t, e, n, s, i) {
  let r, o, a = 0;
  do
    o = e + (n - e) / 2, r = St(o, s, i) - t, r > 0 ? n = o : e = o;
  while (Math.abs(r) > kn && ++a < _n);
  return o;
}
function J(t, e, n, s) {
  if (t === e && n === s)
    return B;
  const i = (r) => Ln(r, 0, 1, t, n);
  return (r) => r === 0 || r === 1 ? r : St(i(r), e, s);
}
const At = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, Mt = (t) => (e) => 1 - t(1 - e), Pt = /* @__PURE__ */ J(0.33, 1.53, 0.69, 0.99), Ee = /* @__PURE__ */ Mt(Pt), Ct = /* @__PURE__ */ At(Ee), Ft = (t) => (t *= 2) < 1 ? 0.5 * Ee(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), Ie = (t) => 1 - Math.sin(Math.acos(t)), $n = Mt(Ie), Dt = At(Ie), Rt = (t) => /^0[^.\s]+$/u.test(t);
function Wn(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || Rt(t) : !0;
}
const Ot = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t), Et = (t) => (e) => typeof e == "string" && e.startsWith(t), It = /* @__PURE__ */ Et("--"), Un = /* @__PURE__ */ Et("var(--"), Ne = (t) => Un(t) ? Gn.test(t.split("/*")[0].trim()) : !1, Gn = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, jn = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function zn(t) {
  const e = jn.exec(t);
  if (!e)
    return [,];
  const [, n, s, i] = e;
  return [`--${n ?? s}`, i];
}
const qn = 4;
function Nt(t, e, n = 1) {
  U(n <= qn, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`);
  const [s, i] = zn(t);
  if (!s)
    return;
  const r = window.getComputedStyle(e).getPropertyValue(s);
  if (r) {
    const o = r.trim();
    return Ot(o) ? parseFloat(o) : o;
  }
  return Ne(i) ? Nt(i, e, n + 1) : i;
}
const _ = (t, e, n) => n > e ? e : n < t ? t : n, j = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, X = {
  ...j,
  transform: (t) => _(0, 1, t)
}, ne = {
  ...j,
  default: 1
}, ee = (t) => ({
  test: (e) => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), E = /* @__PURE__ */ ee("deg"), W = /* @__PURE__ */ ee("%"), h = /* @__PURE__ */ ee("px"), Yn = /* @__PURE__ */ ee("vh"), Xn = /* @__PURE__ */ ee("vw"), Ye = {
  ...W,
  parse: (t) => W.parse(t) / 100,
  transform: (t) => W.transform(t * 100)
}, Hn = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), Xe = (t) => t === j || t === h, He = (t, e) => parseFloat(t.split(", ")[e]), Ze = (t, e) => (n, { transform: s }) => {
  if (s === "none" || !s)
    return 0;
  const i = s.match(/^matrix3d\((.+)\)$/u);
  if (i)
    return He(i[1], e);
  {
    const r = s.match(/^matrix\((.+)\)$/u);
    return r ? He(r[1], t) : 0;
  }
}, Zn = /* @__PURE__ */ new Set(["x", "y", "z"]), Qn = Q.filter((t) => !Zn.has(t));
function Jn(t) {
  const e = [];
  return Qn.forEach((n) => {
    const s = t.getValue(n);
    s !== void 0 && (e.push([n, s.get()]), s.set(n.startsWith("scale") ? 1 : 0));
  }), e;
}
const G = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: Ze(4, 13),
  y: Ze(5, 14)
};
G.translateX = G.x;
G.translateY = G.y;
const Bt = (t) => (e) => e.test(t), es = {
  test: (t) => t === "auto",
  parse: (t) => t
}, Kt = [j, h, W, E, Xn, Yn, es], Qe = (t) => Kt.find(Bt(t)), k = /* @__PURE__ */ new Set();
let be = !1, Te = !1;
function kt() {
  if (Te) {
    const t = Array.from(k).filter((s) => s.needsMeasurement), e = new Set(t.map((s) => s.element)), n = /* @__PURE__ */ new Map();
    e.forEach((s) => {
      const i = Jn(s);
      i.length && (n.set(s, i), s.render());
    }), t.forEach((s) => s.measureInitialState()), e.forEach((s) => {
      s.render();
      const i = n.get(s);
      i && i.forEach(([r, o]) => {
        var a;
        (a = s.getValue(r)) === null || a === void 0 || a.set(o);
      });
    }), t.forEach((s) => s.measureEndState()), t.forEach((s) => {
      s.suspendedScrollY !== void 0 && window.scrollTo(0, s.suspendedScrollY);
    });
  }
  Te = !1, be = !1, k.forEach((t) => t.complete()), k.clear();
}
function _t() {
  k.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (Te = !0);
  });
}
function ts() {
  _t(), kt();
}
class Be {
  constructor(e, n, s, i, r, o = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...e], this.onComplete = n, this.name = s, this.motionValue = i, this.element = r, this.isAsync = o;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (k.add(this), be || (be = !0, O.read(_t), O.resolveKeyframes(kt))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: n, element: s, motionValue: i } = this;
    for (let r = 0; r < e.length; r++)
      if (e[r] === null)
        if (r === 0) {
          const o = i == null ? void 0 : i.get(), a = e[e.length - 1];
          if (o !== void 0)
            e[0] = o;
          else if (s && n) {
            const l = s.readValue(n, a);
            l != null && (e[0] = l);
          }
          e[0] === void 0 && (e[0] = a), i && o === void 0 && i.set(e[0]);
        } else
          e[r] = e[r - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), k.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, k.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const Y = (t) => Math.round(t * 1e5) / 1e5, Ke = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function ns(t) {
  return t == null;
}
const ss = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, ke = (t, e) => (n) => !!(typeof n == "string" && ss.test(n) && n.startsWith(t) || e && !ns(n) && Object.prototype.hasOwnProperty.call(n, e)), Lt = (t, e, n) => (s) => {
  if (typeof s != "string")
    return s;
  const [i, r, o, a] = s.match(Ke);
  return {
    [t]: parseFloat(i),
    [e]: parseFloat(r),
    [n]: parseFloat(o),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, is = (t) => _(0, 255, t), he = {
  ...j,
  transform: (t) => Math.round(is(t))
}, K = {
  test: /* @__PURE__ */ ke("rgb", "red"),
  parse: /* @__PURE__ */ Lt("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: s = 1 }) => "rgba(" + he.transform(t) + ", " + he.transform(e) + ", " + he.transform(n) + ", " + Y(X.transform(s)) + ")"
};
function rs(t) {
  let e = "", n = "", s = "", i = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), s = t.substring(5, 7), i = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), s = t.substring(3, 4), i = t.substring(4, 5), e += e, n += n, s += s, i += i), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(s, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const Ve = {
  test: /* @__PURE__ */ ke("#"),
  parse: rs,
  transform: K.transform
}, $ = {
  test: /* @__PURE__ */ ke("hsl", "hue"),
  parse: /* @__PURE__ */ Lt("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: s = 1 }) => "hsla(" + Math.round(t) + ", " + W.transform(Y(e)) + ", " + W.transform(Y(n)) + ", " + Y(X.transform(s)) + ")"
}, S = {
  test: (t) => K.test(t) || Ve.test(t) || $.test(t),
  parse: (t) => K.test(t) ? K.parse(t) : $.test(t) ? $.parse(t) : Ve.parse(t),
  transform: (t) => typeof t == "string" ? t : t.hasOwnProperty("red") ? K.transform(t) : $.transform(t)
}, os = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function as(t) {
  var e, n;
  return isNaN(t) && typeof t == "string" && (((e = t.match(Ke)) === null || e === void 0 ? void 0 : e.length) || 0) + (((n = t.match(os)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const $t = "number", Wt = "color", ls = "var", us = "var(", Je = "${}", cs = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function H(t) {
  const e = t.toString(), n = [], s = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let r = 0;
  const a = e.replace(cs, (l) => (S.test(l) ? (s.color.push(r), i.push(Wt), n.push(S.parse(l))) : l.startsWith(us) ? (s.var.push(r), i.push(ls), n.push(l)) : (s.number.push(r), i.push($t), n.push(parseFloat(l))), ++r, Je)).split(Je);
  return { values: n, split: a, indexes: s, types: i };
}
function Ut(t) {
  return H(t).values;
}
function Gt(t) {
  const { split: e, types: n } = H(t), s = e.length;
  return (i) => {
    let r = "";
    for (let o = 0; o < s; o++)
      if (r += e[o], i[o] !== void 0) {
        const a = n[o];
        a === $t ? r += Y(i[o]) : a === Wt ? r += S.transform(i[o]) : r += i[o];
      }
    return r;
  };
}
const fs = (t) => typeof t == "number" ? 0 : t;
function ds(t) {
  const e = Ut(t);
  return Gt(t)(e.map(fs));
}
const z = {
  test: as,
  parse: Ut,
  createTransformer: Gt,
  getAnimatableNone: ds
}, hs = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function ps(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [s] = n.match(Ke) || [];
  if (!s)
    return t;
  const i = n.replace(s, "");
  let r = hs.has(e) ? 1 : 0;
  return s !== n && (r *= 100), e + "(" + r + i + ")";
}
const ms = /\b([a-z-]*)\(.*?\)/gu, we = {
  ...z,
  getAnimatableNone: (t) => {
    const e = t.match(ms);
    return e ? e.map(ps).join(" ") : t;
  }
}, gs = {
  // Border props
  borderWidth: h,
  borderTopWidth: h,
  borderRightWidth: h,
  borderBottomWidth: h,
  borderLeftWidth: h,
  borderRadius: h,
  radius: h,
  borderTopLeftRadius: h,
  borderTopRightRadius: h,
  borderBottomRightRadius: h,
  borderBottomLeftRadius: h,
  // Positioning props
  width: h,
  maxWidth: h,
  height: h,
  maxHeight: h,
  top: h,
  right: h,
  bottom: h,
  left: h,
  // Spacing props
  padding: h,
  paddingTop: h,
  paddingRight: h,
  paddingBottom: h,
  paddingLeft: h,
  margin: h,
  marginTop: h,
  marginRight: h,
  marginBottom: h,
  marginLeft: h,
  // Misc
  backgroundPositionX: h,
  backgroundPositionY: h
}, ys = {
  rotate: E,
  rotateX: E,
  rotateY: E,
  rotateZ: E,
  scale: ne,
  scaleX: ne,
  scaleY: ne,
  scaleZ: ne,
  skew: E,
  skewX: E,
  skewY: E,
  distance: h,
  translateX: h,
  translateY: h,
  translateZ: h,
  x: h,
  y: h,
  z: h,
  perspective: h,
  transformPerspective: h,
  opacity: X,
  originX: Ye,
  originY: Ye,
  originZ: h
}, et = {
  ...j,
  transform: Math.round
}, _e = {
  ...gs,
  ...ys,
  zIndex: et,
  size: h,
  // SVG
  fillOpacity: X,
  strokeOpacity: X,
  numOctaves: et
}, vs = {
  ..._e,
  // Color props
  color: S,
  backgroundColor: S,
  outlineColor: S,
  fill: S,
  stroke: S,
  // Border props
  borderColor: S,
  borderTopColor: S,
  borderRightColor: S,
  borderBottomColor: S,
  borderLeftColor: S,
  filter: we,
  WebkitFilter: we
}, Le = (t) => vs[t];
function jt(t, e) {
  let n = Le(t);
  return n !== we && (n = z), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
}
const bs = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function Ts(t, e, n) {
  let s = 0, i;
  for (; s < t.length && !i; ) {
    const r = t[s];
    typeof r == "string" && !bs.has(r) && H(r).values.length && (i = t[s]), s++;
  }
  if (i && n)
    for (const r of e)
      t[r] = jt(n, i);
}
class zt extends Be {
  constructor(e, n, s, i, r) {
    super(e, n, s, i, r, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: n, name: s } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < e.length; l++) {
      let u = e[l];
      if (typeof u == "string" && (u = u.trim(), Ne(u))) {
        const c = Nt(u, n.current);
        c !== void 0 && (e[l] = c), l === e.length - 1 && (this.finalKeyframe = u);
      }
    }
    if (this.resolveNoneKeyframes(), !Hn.has(s) || e.length !== 2)
      return;
    const [i, r] = e, o = Qe(i), a = Qe(r);
    if (o !== a)
      if (Xe(o) && Xe(a))
        for (let l = 0; l < e.length; l++) {
          const u = e[l];
          typeof u == "string" && (e[l] = parseFloat(u));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: n } = this, s = [];
    for (let i = 0; i < e.length; i++)
      Wn(e[i]) && s.push(i);
    s.length && Ts(e, s, n);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: n, name: s } = this;
    if (!e || !e.current)
      return;
    s === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = G[s](e.measureViewportBox(), window.getComputedStyle(e.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && e.getValue(s, i).jump(i, !1);
  }
  measureEndState() {
    var e;
    const { element: n, name: s, unresolvedKeyframes: i } = this;
    if (!n || !n.current)
      return;
    const r = n.getValue(s);
    r && r.jump(this.measuredOrigin, !1);
    const o = i.length - 1, a = i[o];
    i[o] = G[s](n.measureViewportBox(), window.getComputedStyle(n.current)), a !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = a), !((e = this.removedTransforms) === null || e === void 0) && e.length && this.removedTransforms.forEach(([l, u]) => {
      n.getValue(l).set(u);
    }), this.resolveNoneKeyframes();
  }
}
const tt = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(z.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function Vs(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e)
      return !0;
}
function ws(t, e, n, s) {
  const i = t[0];
  if (i === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const r = t[t.length - 1], o = tt(i, e), a = tt(r, e);
  return Z(o === a, `You are trying to animate ${e} from "${i}" to "${r}". ${i} is not an animatable value - to enable this animation set ${i} to a value animatable to ${r} via the \`style\` property.`), !o || !a ? !1 : Vs(t) || (n === "spring" || De(n)) && s;
}
const xs = (t) => t !== null;
function ce(t, { repeat: e, repeatType: n = "loop" }, s) {
  const i = t.filter(xs), r = e && n !== "loop" && e % 2 === 1 ? 0 : i.length - 1;
  return !r || s === void 0 ? i[r] : s;
}
const Ss = 40;
class qt {
  constructor({ autoplay: e = !0, delay: n = 0, type: s = "keyframes", repeat: i = 0, repeatDelay: r = 0, repeatType: o = "loop", ...a }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = N.now(), this.options = {
      autoplay: e,
      delay: n,
      type: s,
      repeat: i,
      repeatDelay: r,
      repeatType: o,
      ...a
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > Ss ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && ts(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(e, n) {
    this.resolvedAt = N.now(), this.hasAttemptedResolve = !0;
    const { name: s, type: i, velocity: r, delay: o, onComplete: a, onUpdate: l, isGenerator: u } = this.options;
    if (!u && !ws(e, s, i, r))
      if (o)
        this.options.duration = 0;
      else {
        l == null || l(ce(e, this.options, n)), a == null || a(), this.resolveFinishedPromise();
        return;
      }
    const c = this.initPlayback(e, n);
    c !== !1 && (this._resolved = {
      keyframes: e,
      finalKeyframe: n,
      ...c
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, n) {
    return this.currentFinishedPromise.then(e, n);
  }
  flatten() {
    this.options.type = "keyframes", this.options.ease = "linear";
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((e) => {
      this.resolveFinishedPromise = e;
    });
  }
}
const fe = (t, e, n) => t + (e - t) * n;
function pe(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function As({ hue: t, saturation: e, lightness: n, alpha: s }) {
  t /= 360, e /= 100, n /= 100;
  let i = 0, r = 0, o = 0;
  if (!e)
    i = r = o = n;
  else {
    const a = n < 0.5 ? n * (1 + e) : n + e - n * e, l = 2 * n - a;
    i = pe(l, a, t + 1 / 3), r = pe(l, a, t), o = pe(l, a, t - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(r * 255),
    blue: Math.round(o * 255),
    alpha: s
  };
}
function ae(t, e) {
  return (n) => n > 0 ? e : t;
}
const me = (t, e, n) => {
  const s = t * t, i = n * (e * e - s) + s;
  return i < 0 ? 0 : Math.sqrt(i);
}, Ms = [Ve, K, $], Ps = (t) => Ms.find((e) => e.test(t));
function nt(t) {
  const e = Ps(t);
  if (Z(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`), !e)
    return !1;
  let n = e.parse(t);
  return e === $ && (n = As(n)), n;
}
const st = (t, e) => {
  const n = nt(t), s = nt(e);
  if (!n || !s)
    return ae(t, e);
  const i = { ...n };
  return (r) => (i.red = me(n.red, s.red, r), i.green = me(n.green, s.green, r), i.blue = me(n.blue, s.blue, r), i.alpha = fe(n.alpha, s.alpha, r), K.transform(i));
}, Cs = (t, e) => (n) => e(t(n)), $e = (...t) => t.reduce(Cs), xe = /* @__PURE__ */ new Set(["none", "hidden"]);
function Fs(t, e) {
  return xe.has(t) ? (n) => n <= 0 ? t : e : (n) => n >= 1 ? e : t;
}
function Ds(t, e) {
  return (n) => fe(t, e, n);
}
function We(t) {
  return typeof t == "number" ? Ds : typeof t == "string" ? Ne(t) ? ae : S.test(t) ? st : Es : Array.isArray(t) ? Yt : typeof t == "object" ? S.test(t) ? st : Rs : ae;
}
function Yt(t, e) {
  const n = [...t], s = n.length, i = t.map((r, o) => We(r)(r, e[o]));
  return (r) => {
    for (let o = 0; o < s; o++)
      n[o] = i[o](r);
    return n;
  };
}
function Rs(t, e) {
  const n = { ...t, ...e }, s = {};
  for (const i in n)
    t[i] !== void 0 && e[i] !== void 0 && (s[i] = We(t[i])(t[i], e[i]));
  return (i) => {
    for (const r in s)
      n[r] = s[r](i);
    return n;
  };
}
function Os(t, e) {
  var n;
  const s = [], i = { color: 0, var: 0, number: 0 };
  for (let r = 0; r < e.values.length; r++) {
    const o = e.types[r], a = t.indexes[o][i[o]], l = (n = t.values[a]) !== null && n !== void 0 ? n : 0;
    s[r] = l, i[o]++;
  }
  return s;
}
const Es = (t, e) => {
  const n = z.createTransformer(e), s = H(t), i = H(e);
  return s.indexes.var.length === i.indexes.var.length && s.indexes.color.length === i.indexes.color.length && s.indexes.number.length >= i.indexes.number.length ? xe.has(t) && !i.values.length || xe.has(e) && !s.values.length ? Fs(t, e) : $e(Yt(Os(s, i), i.values), n) : (Z(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), ae(t, e));
};
function Xt(t, e, n) {
  return typeof t == "number" && typeof e == "number" && typeof n == "number" ? fe(t, e, n) : We(t)(t, e);
}
const Is = 5;
function Ht(t, e, n) {
  const s = Math.max(e - Is, 0);
  return xt(n - t(s), e - s);
}
const T = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, it = 1e-3;
function Ns({ duration: t = T.duration, bounce: e = T.bounce, velocity: n = T.velocity, mass: s = T.mass }) {
  let i, r;
  Z(t <= R(T.maxDuration), "Spring duration must be 10 seconds or less");
  let o = 1 - e;
  o = _(T.minDamping, T.maxDamping, o), t = _(T.minDuration, T.maxDuration, I(t)), o < 1 ? (i = (u) => {
    const c = u * o, f = c * t, d = c - n, y = Se(u, o), b = Math.exp(-f);
    return it - d / y * b;
  }, r = (u) => {
    const f = u * o * t, d = f * n + n, y = Math.pow(o, 2) * Math.pow(u, 2) * t, b = Math.exp(-f), v = Se(Math.pow(u, 2), o);
    return (-i(u) + it > 0 ? -1 : 1) * ((d - y) * b) / v;
  }) : (i = (u) => {
    const c = Math.exp(-u * t), f = (u - n) * t + 1;
    return -1e-3 + c * f;
  }, r = (u) => {
    const c = Math.exp(-u * t), f = (n - u) * (t * t);
    return c * f;
  });
  const a = 5 / t, l = Ks(i, r, a);
  if (t = R(t), isNaN(l))
    return {
      stiffness: T.stiffness,
      damping: T.damping,
      duration: t
    };
  {
    const u = Math.pow(l, 2) * s;
    return {
      stiffness: u,
      damping: o * 2 * Math.sqrt(s * u),
      duration: t
    };
  }
}
const Bs = 12;
function Ks(t, e, n) {
  let s = n;
  for (let i = 1; i < Bs; i++)
    s = s - t(s) / e(s);
  return s;
}
function Se(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const ks = ["duration", "bounce"], _s = ["stiffness", "damping", "mass"];
function rt(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function Ls(t) {
  let e = {
    velocity: T.velocity,
    stiffness: T.stiffness,
    damping: T.damping,
    mass: T.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!rt(t, _s) && rt(t, ks))
    if (t.visualDuration) {
      const n = t.visualDuration, s = 2 * Math.PI / (n * 1.2), i = s * s, r = 2 * _(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(i);
      e = {
        ...e,
        mass: T.mass,
        stiffness: i,
        damping: r
      };
    } else {
      const n = Ns(t);
      e = {
        ...e,
        ...n,
        mass: T.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function Zt(t = T.visualDuration, e = T.bounce) {
  const n = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: e
  } : t;
  let { restSpeed: s, restDelta: i } = n;
  const r = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], a = { done: !1, value: r }, { stiffness: l, damping: u, mass: c, duration: f, velocity: d, isResolvedFromDuration: y } = Ls({
    ...n,
    velocity: -I(n.velocity || 0)
  }), b = d || 0, v = u / (2 * Math.sqrt(l * c)), V = o - r, p = I(Math.sqrt(l / c)), x = Math.abs(V) < 5;
  s || (s = x ? T.restSpeed.granular : T.restSpeed.default), i || (i = x ? T.restDelta.granular : T.restDelta.default);
  let M;
  if (v < 1) {
    const m = Se(p, v);
    M = (w) => {
      const A = Math.exp(-v * p * w);
      return o - A * ((b + v * p * V) / m * Math.sin(m * w) + V * Math.cos(m * w));
    };
  } else if (v === 1)
    M = (m) => o - Math.exp(-p * m) * (V + (b + p * V) * m);
  else {
    const m = p * Math.sqrt(v * v - 1);
    M = (w) => {
      const A = Math.exp(-v * p * w), g = Math.min(m * w, 300);
      return o - A * ((b + v * p * V) * Math.sinh(g) + m * V * Math.cosh(g)) / m;
    };
  }
  const C = {
    calculatedDuration: y && f || null,
    next: (m) => {
      const w = M(m);
      if (y)
        a.done = m >= f;
      else {
        let A = 0;
        v < 1 && (A = m === 0 ? R(b) : Ht(M, m, w));
        const g = Math.abs(A) <= s, F = Math.abs(o - w) <= i;
        a.done = g && F;
      }
      return a.value = a.done ? o : w, a;
    },
    toString: () => {
      const m = Math.min(yt(C), ge), w = vt((A) => C.next(m * A).value, m, 30);
      return m + "ms " + w;
    }
  };
  return C;
}
function ot({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: s = 325, bounceDamping: i = 10, bounceStiffness: r = 500, modifyTarget: o, min: a, max: l, restDelta: u = 0.5, restSpeed: c }) {
  const f = t[0], d = {
    done: !1,
    value: f
  }, y = (g) => a !== void 0 && g < a || l !== void 0 && g > l, b = (g) => a === void 0 ? l : l === void 0 || Math.abs(a - g) < Math.abs(l - g) ? a : l;
  let v = n * e;
  const V = f + v, p = o === void 0 ? V : o(V);
  p !== V && (v = p - f);
  const x = (g) => -v * Math.exp(-g / s), M = (g) => p + x(g), C = (g) => {
    const F = x(g), D = M(g);
    d.done = Math.abs(F) <= u, d.value = d.done ? p : D;
  };
  let m, w;
  const A = (g) => {
    y(d.value) && (m = g, w = Zt({
      keyframes: [d.value, b(d.value)],
      velocity: Ht(M, g, d.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: r,
      restDelta: u,
      restSpeed: c
    }));
  };
  return A(0), {
    calculatedDuration: null,
    next: (g) => {
      let F = !1;
      return !w && m === void 0 && (F = !0, C(g), A(g)), m !== void 0 && g >= m ? w.next(g - m) : (!F && C(g), d);
    }
  };
}
const $s = /* @__PURE__ */ J(0.42, 0, 1, 1), Ws = /* @__PURE__ */ J(0, 0, 0.58, 1), Qt = /* @__PURE__ */ J(0.42, 0, 0.58, 1), Us = (t) => Array.isArray(t) && typeof t[0] != "number", at = {
  linear: B,
  easeIn: $s,
  easeInOut: Qt,
  easeOut: Ws,
  circIn: Ie,
  circInOut: Dt,
  circOut: $n,
  backIn: Ee,
  backInOut: Ct,
  backOut: Pt,
  anticipate: Ft
}, lt = (t) => {
  if (Re(t)) {
    U(t.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [e, n, s, i] = t;
    return J(e, n, s, i);
  } else if (typeof t == "string")
    return U(at[t] !== void 0, `Invalid easing type '${t}'`), at[t];
  return t;
};
function Gs(t, e, n) {
  const s = [], i = n || Xt, r = t.length - 1;
  for (let o = 0; o < r; o++) {
    let a = i(t[o], t[o + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[o] || B : e;
      a = $e(l, a);
    }
    s.push(a);
  }
  return s;
}
function js(t, e, { clamp: n = !0, ease: s, mixer: i } = {}) {
  const r = t.length;
  if (U(r === e.length, "Both input and output ranges must be the same length"), r === 1)
    return () => e[0];
  if (r === 2 && t[0] === t[1])
    return () => e[1];
  t[0] > t[r - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const o = Gs(e, s, i), a = o.length, l = (u) => {
    let c = 0;
    if (a > 1)
      for (; c < t.length - 2 && !(u < t[c + 1]); c++)
        ;
    const f = Fe(t[c], t[c + 1], u);
    return o[c](f);
  };
  return n ? (u) => l(_(t[0], t[r - 1], u)) : l;
}
function zs(t, e) {
  const n = t[t.length - 1];
  for (let s = 1; s <= e; s++) {
    const i = Fe(0, e, s);
    t.push(fe(n, 1, i));
  }
}
function qs(t) {
  const e = [0];
  return zs(e, t.length - 1), e;
}
function Ys(t, e) {
  return t.map((n) => n * e);
}
function Xs(t, e) {
  return t.map(() => e || Qt).splice(0, t.length - 1);
}
function le({ duration: t = 300, keyframes: e, times: n, ease: s = "easeInOut" }) {
  const i = Us(s) ? s.map(lt) : lt(s), r = {
    done: !1,
    value: e[0]
  }, o = Ys(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : qs(e),
    t
  ), a = js(o, e, {
    ease: Array.isArray(i) ? i : Xs(e, i)
  });
  return {
    calculatedDuration: t,
    next: (l) => (r.value = a(l), r.done = l >= t, r)
  };
}
const Hs = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: () => O.update(e, !0),
    stop: () => ve(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => re.isProcessing ? re.timestamp : N.now()
  };
}, Zs = {
  decay: ot,
  inertia: ot,
  tween: le,
  keyframes: le,
  spring: Zt
}, Qs = (t) => t / 100;
class de extends qt {
  constructor(e) {
    super(e), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: l } = this.options;
      l && l();
    };
    const { name: n, motionValue: s, element: i, keyframes: r } = this.options, o = (i == null ? void 0 : i.KeyframeResolver) || Be, a = (l, u) => this.onKeyframesResolved(l, u);
    this.resolver = new o(r, a, n, s, i), this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
  }
  initPlayback(e) {
    const { type: n = "keyframes", repeat: s = 0, repeatDelay: i = 0, repeatType: r, velocity: o = 0 } = this.options, a = De(n) ? n : Zs[n] || le;
    let l, u;
    a !== le && typeof e[0] != "number" && (process.env.NODE_ENV !== "production" && U(e.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${e}`), l = $e(Qs, Xt(e[0], e[1])), e = [0, 100]);
    const c = a({ ...this.options, keyframes: e });
    r === "mirror" && (u = a({
      ...this.options,
      keyframes: [...e].reverse(),
      velocity: -o
    })), c.calculatedDuration === null && (c.calculatedDuration = yt(c));
    const { calculatedDuration: f } = c, d = f + i, y = d * (s + 1) - i;
    return {
      generator: c,
      mirroredGenerator: u,
      mapPercentToKeyframes: l,
      calculatedDuration: f,
      resolvedDuration: d,
      totalDuration: y
    };
  }
  onPostResolved() {
    const { autoplay: e = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !e ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(e, n = !1) {
    const { resolved: s } = this;
    if (!s) {
      const { keyframes: g } = this.options;
      return { done: !0, value: g[g.length - 1] };
    }
    const { finalKeyframe: i, generator: r, mirroredGenerator: o, mapPercentToKeyframes: a, keyframes: l, calculatedDuration: u, totalDuration: c, resolvedDuration: f } = s;
    if (this.startTime === null)
      return r.next(0);
    const { delay: d, repeat: y, repeatType: b, repeatDelay: v, onUpdate: V } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - c / this.speed, this.startTime)), n ? this.currentTime = e : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(e - this.startTime) * this.speed;
    const p = this.currentTime - d * (this.speed >= 0 ? 1 : -1), x = this.speed >= 0 ? p < 0 : p > c;
    this.currentTime = Math.max(p, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = c);
    let M = this.currentTime, C = r;
    if (y) {
      const g = Math.min(this.currentTime, c) / f;
      let F = Math.floor(g), D = g % 1;
      !D && g >= 1 && (D = 1), D === 1 && F--, F = Math.min(F, y + 1), !!(F % 2) && (b === "reverse" ? (D = 1 - D, v && (D -= v / f)) : b === "mirror" && (C = o)), M = _(0, 1, D) * f;
    }
    const m = x ? { done: !1, value: l[0] } : C.next(M);
    a && (m.value = a(m.value));
    let { done: w } = m;
    !x && u !== null && (w = this.speed >= 0 ? this.currentTime >= c : this.currentTime <= 0);
    const A = this.holdTime === null && (this.state === "finished" || this.state === "running" && w);
    return A && i !== void 0 && (m.value = ce(l, this.options, i)), V && V(m.value), A && this.finish(), m;
  }
  get duration() {
    const { resolved: e } = this;
    return e ? I(e.calculatedDuration) : 0;
  }
  get time() {
    return I(this.currentTime);
  }
  set time(e) {
    e = R(e), this.currentTime = e, this.holdTime !== null || this.speed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    const n = this.playbackSpeed !== e;
    this.playbackSpeed = e, n && (this.time = I(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: e = Hs, onPlay: n, startTime: s } = this.options;
    this.driver || (this.driver = e((r) => this.tick(r))), n && n();
    const i = this.driver.now();
    this.holdTime !== null ? this.startTime = i - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = i) : this.startTime = s ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var e;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (e = this.currentTime) !== null && e !== void 0 ? e : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: e } = this.options;
    e && e();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
}
function Ui(t) {
  return new de(t);
}
const Js = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
function ei(t, e, n, { delay: s = 0, duration: i = 300, repeat: r = 0, repeatType: o = "loop", ease: a = "easeInOut", times: l } = {}) {
  const u = { [e]: n };
  l && (u.offset = l);
  const c = Tt(a, i);
  return Array.isArray(c) && (u.easing = c), t.animate(u, {
    delay: s,
    duration: i,
    easing: Array.isArray(c) ? "linear" : c,
    fill: "both",
    iterations: r + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  });
}
const ti = /* @__PURE__ */ Ce(() => Object.hasOwnProperty.call(Element.prototype, "animate")), ue = 10, ni = 2e4;
function si(t) {
  return De(t.type) || t.type === "spring" || !bt(t.ease);
}
function ii(t, e) {
  const n = new de({
    ...e,
    keyframes: t,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let s = { done: !1, value: t[0] };
  const i = [];
  let r = 0;
  for (; !s.done && r < ni; )
    s = n.sample(r), i.push(s.value), r += ue;
  return {
    times: void 0,
    keyframes: i,
    duration: r - ue,
    ease: "linear"
  };
}
const Jt = {
  anticipate: Ft,
  backInOut: Ct,
  circInOut: Dt
};
function ri(t) {
  return t in Jt;
}
class ut extends qt {
  constructor(e) {
    super(e);
    const { name: n, motionValue: s, element: i, keyframes: r } = this.options;
    this.resolver = new zt(r, (o, a) => this.onKeyframesResolved(o, a), n, s, i), this.resolver.scheduleResolve();
  }
  initPlayback(e, n) {
    var s;
    let { duration: i = 300, times: r, ease: o, type: a, motionValue: l, name: u, startTime: c } = this.options;
    if (!(!((s = l.owner) === null || s === void 0) && s.current))
      return !1;
    if (typeof o == "string" && ie() && ri(o) && (o = Jt[o]), si(this.options)) {
      const { onComplete: d, onUpdate: y, motionValue: b, element: v, ...V } = this.options, p = ii(e, V);
      e = p.keyframes, e.length === 1 && (e[1] = e[0]), i = p.duration, r = p.times, o = p.ease, a = "keyframes";
    }
    const f = ei(l.owner.current, u, e, { ...this.options, duration: i, times: r, ease: o });
    return f.startTime = c ?? this.calcStartTime(), this.pendingTimeline ? (je(f, this.pendingTimeline), this.pendingTimeline = void 0) : f.onfinish = () => {
      const { onComplete: d } = this.options;
      l.set(ce(e, this.options, n)), d && d(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: f,
      duration: i,
      times: r,
      type: a,
      ease: o,
      keyframes: e
    };
  }
  get duration() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { duration: n } = e;
    return I(n);
  }
  get time() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { animation: n } = e;
    return I(n.currentTime || 0);
  }
  set time(e) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: s } = n;
    s.currentTime = R(e);
  }
  get speed() {
    const { resolved: e } = this;
    if (!e)
      return 1;
    const { animation: n } = e;
    return n.playbackRate;
  }
  set speed(e) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: s } = n;
    s.playbackRate = e;
  }
  get state() {
    const { resolved: e } = this;
    if (!e)
      return "idle";
    const { animation: n } = e;
    return n.playState;
  }
  get startTime() {
    const { resolved: e } = this;
    if (!e)
      return null;
    const { animation: n } = e;
    return n.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(e) {
    if (!this._resolved)
      this.pendingTimeline = e;
    else {
      const { resolved: n } = this;
      if (!n)
        return B;
      const { animation: s } = n;
      je(s, e);
    }
    return B;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.playState === "finished" && this.updateFinishedPromise(), n.play();
  }
  pause() {
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n } = e;
    n.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: n, keyframes: s, duration: i, type: r, ease: o, times: a } = e;
    if (n.playState === "idle" || n.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: u, onUpdate: c, onComplete: f, element: d, ...y } = this.options, b = new de({
        ...y,
        keyframes: s,
        duration: i,
        type: r,
        ease: o,
        times: a,
        isGenerator: !0
      }), v = R(this.time);
      u.setWithVelocity(b.sample(v - ue).value, b.sample(v).value, ue);
    }
    const { onStop: l } = this.options;
    l && l(), this.cancel();
  }
  complete() {
    const { resolved: e } = this;
    e && e.animation.finish();
  }
  cancel() {
    const { resolved: e } = this;
    e && e.animation.cancel();
  }
  static supports(e) {
    const { motionValue: n, name: s, repeatDelay: i, repeatType: r, damping: o, type: a } = e;
    return ti() && s && Js.has(s) && n && n.owner && n.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !n.owner.getProps().onUpdate && !i && r !== "mirror" && o !== 0 && a !== "inertia";
  }
}
const oi = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, ai = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), li = {
  type: "keyframes",
  duration: 0.8
}, ui = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, ci = (t, { keyframes: e }) => e.length > 2 ? li : L.has(t) ? t.startsWith("scale") ? ai(e[1]) : oi : ui;
function fi({ when: t, delay: e, delayChildren: n, staggerChildren: s, staggerDirection: i, repeat: r, repeatType: o, repeatDelay: a, from: l, elapsed: u, ...c }) {
  return !!Object.keys(c).length;
}
const di = (t, e, n, s = {}, i, r) => (o) => {
  const a = gt(s, t) || {}, l = a.delay || s.delay || 0;
  let { elapsed: u = 0 } = s;
  u = u - R(l);
  let c = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...a,
    delay: -u,
    onUpdate: (d) => {
      e.set(d), a.onUpdate && a.onUpdate(d);
    },
    onComplete: () => {
      o(), a.onComplete && a.onComplete();
    },
    name: t,
    motionValue: e,
    element: r ? void 0 : i
  };
  fi(a) || (c = {
    ...c,
    ...ci(t, c)
  }), c.duration && (c.duration = R(c.duration)), c.repeatDelay && (c.repeatDelay = R(c.repeatDelay)), c.from !== void 0 && (c.keyframes[0] = c.from);
  let f = !1;
  if ((c.type === !1 || c.duration === 0 && !c.repeatDelay) && (c.duration = 0, c.delay === 0 && (f = !0)), Vt.skipAnimations && (f = !0, c.duration = 0, c.delay = 0), f && !r && e.get() !== void 0) {
    const d = ce(c.keyframes, a);
    if (d !== void 0)
      return O.update(() => {
        c.onUpdate(d), c.onComplete();
      }), new bn([]);
  }
  return !r && ut.supports(c) ? new ut(c) : new de(c);
};
function hi({ protectedKeys: t, needsAnimating: e }, n) {
  const s = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, s;
}
function Gi(t, e, { delay: n = 0, transitionOverride: s, type: i } = {}) {
  var r;
  let { transition: o = t.getDefaultTransition(), transitionEnd: a, ...l } = e;
  s && (o = s);
  const u = [], c = i && t.animationState && t.animationState.getState()[i];
  for (const f in l) {
    const d = t.getValue(f, (r = t.latestValues[f]) !== null && r !== void 0 ? r : null), y = l[f];
    if (y === void 0 || c && hi(c, f))
      continue;
    const b = {
      delay: n,
      ...gt(o || {}, f)
    };
    let v = !1;
    if (window.MotionHandoffAnimation) {
      const p = Kn(t);
      if (p) {
        const x = window.MotionHandoffAnimation(p, f, O);
        x !== null && (b.startTime = x, v = !0);
      }
    }
    In(t, f), d.start(di(f, d, y, t.shouldReduceMotion && L.has(f) ? { type: !1 } : b, t, v));
    const V = d.animation;
    V && u.push(V);
  }
  return a && Promise.all(u).then(() => {
    O.update(() => {
      a && On(t, a);
    });
  }), u;
}
const ct = () => ({ min: 0, max: 0 }), en = () => ({
  x: ct(),
  y: ct()
});
function pi({ top: t, left: e, right: n, bottom: s }) {
  return {
    x: { min: e, max: n },
    y: { min: t, max: s }
  };
}
function mi(t, e) {
  if (!e)
    return t;
  const n = e({ x: t.left, y: t.top }), s = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: s.y,
    right: s.x
  };
}
function gi(t, e) {
  return pi(mi(t.getBoundingClientRect(), e));
}
const yi = {}, vi = typeof window < "u";
function tn(t) {
  return fn(t.animate) || gn.some((e) => hn(t[e]));
}
function bi(t) {
  return !!(tn(t) || t.variants);
}
const ft = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, Ae = {};
for (const t in ft)
  Ae[t] = {
    isEnabled: (e) => ft[t].some((n) => !!e[n])
  };
function nn(t, { style: e, vars: n }, s, i) {
  Object.assign(t.style, e, i && i.getProjectionStyles(s));
  for (const r in n)
    t.style.setProperty(r, n[r]);
}
const sn = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function Ti(t, e, n, s) {
  nn(t, e, void 0, s);
  for (const i in e.attrs)
    t.setAttribute(sn.has(i) ? i : Oe(i), e.attrs[i]);
}
function Vi(t, { layout: e, layoutId: n }) {
  return L.has(t) || t.startsWith("origin") || (e || n !== void 0) && (!!yi[t] || t === "opacity");
}
function rn(t, e, n) {
  var s;
  const { style: i } = t, r = {};
  for (const o in i)
    (P(i[o]) || e.style && P(e.style[o]) || Vi(o, t) || ((s = n == null ? void 0 : n.getValue(o)) === null || s === void 0 ? void 0 : s.liveStyle) !== void 0) && (r[o] = i[o]);
  return r;
}
function wi(t, e, n) {
  const s = rn(t, e, n);
  for (const i in t)
    if (P(t[i]) || P(e[i])) {
      const r = Q.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      s[r] = t[i];
    }
  return s;
}
function ji(t) {
  const e = cn(null);
  return e.current === null && (e.current = t()), e.current;
}
const on = (t, e) => e && typeof t == "number" ? e.transform(t) : t, xi = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, Si = Q.length;
function Ai(t, e, n) {
  let s = "", i = !0;
  for (let r = 0; r < Si; r++) {
    const o = Q[r], a = t[o];
    if (a === void 0)
      continue;
    let l = !0;
    if (typeof a == "number" ? l = a === (o.startsWith("scale") ? 1 : 0) : l = parseFloat(a) === 0, !l || n) {
      const u = on(a, _e[o]);
      if (!l) {
        i = !1;
        const c = xi[o] || o;
        s += `${c}(${u}) `;
      }
      n && (e[o] = u);
    }
  }
  return s = s.trim(), n ? s = n(e, i ? "" : s) : i && (s = "none"), s;
}
function an(t, e, n) {
  const { style: s, vars: i, transformOrigin: r } = t;
  let o = !1, a = !1;
  for (const l in e) {
    const u = e[l];
    if (L.has(l)) {
      o = !0;
      continue;
    } else if (It(l)) {
      i[l] = u;
      continue;
    } else {
      const c = on(u, _e[l]);
      l.startsWith("origin") ? (a = !0, r[l] = c) : s[l] = c;
    }
  }
  if (e.transform || (o || n ? s.transform = Ai(e, t.transform, n) : s.transform && (s.transform = "none")), a) {
    const { originX: l = "50%", originY: u = "50%", originZ: c = 0 } = r;
    s.transformOrigin = `${l} ${u} ${c}`;
  }
}
function dt(t, e, n) {
  return typeof t == "string" ? t : h.transform(e + n * t);
}
function Mi(t, e, n) {
  const s = dt(e, t.x, t.width), i = dt(n, t.y, t.height);
  return `${s} ${i}`;
}
const Pi = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, Ci = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Fi(t, e, n = 1, s = 0, i = !0) {
  t.pathLength = 1;
  const r = i ? Pi : Ci;
  t[r.offset] = h.transform(-s);
  const o = h.transform(e), a = h.transform(n);
  t[r.array] = `${o} ${a}`;
}
function Di(t, {
  attrX: e,
  attrY: n,
  attrScale: s,
  originX: i,
  originY: r,
  pathLength: o,
  pathSpacing: a = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...u
}, c, f) {
  if (an(t, u, f), c) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: d, style: y, dimensions: b } = t;
  d.transform && (b && (y.transform = d.transform), delete d.transform), b && (i !== void 0 || r !== void 0 || y.transform) && (y.transformOrigin = Mi(b, i !== void 0 ? i : 0.5, r !== void 0 ? r : 0.5)), e !== void 0 && (d.x = e), n !== void 0 && (d.y = n), s !== void 0 && (d.scale = s), o !== void 0 && Fi(d, o, a, l, !1);
}
const Ri = (t) => typeof t == "string" && t.toLowerCase() === "svg", Me = { current: null }, ln = { current: !1 };
function Oi() {
  if (ln.current = !0, !!vi)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => Me.current = t.matches;
      t.addListener(e), e();
    } else
      Me.current = !1;
}
function Ei(t, e, n) {
  for (const s in e) {
    const i = e[s], r = n[s];
    if (P(i))
      t.addValue(s, i), process.env.NODE_ENV === "development" && Pe(i.version === "11.16.0", `Attempting to mix Motion versions ${i.version} with 11.16.0 may not work as expected.`);
    else if (P(r))
      t.addValue(s, oe(i, { owner: t }));
    else if (r !== i)
      if (t.hasValue(s)) {
        const o = t.getValue(s);
        o.liveStyle === !0 ? o.jump(i) : o.hasAnimated || o.set(i);
      } else {
        const o = t.getStaticValue(s);
        t.addValue(s, oe(o !== void 0 ? o : i, { owner: t }));
      }
  }
  for (const s in n)
    e[s] === void 0 && t.removeValue(s);
  return e;
}
const ht = /* @__PURE__ */ new WeakMap(), Ii = [...Kt, S, z], Ni = (t) => Ii.find(Bt(t)), pt = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class Bi {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, n, s) {
    return {};
  }
  constructor({ parent: e, props: n, presenceContext: s, reducedMotionConfig: i, blockInitialAnimation: r, visualState: o }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = Be, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const d = N.now();
      this.renderScheduledAt < d && (this.renderScheduledAt = d, O.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: u } = o;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = u, this.parent = e, this.props = n, this.presenceContext = s, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = i, this.options = a, this.blockInitialAnimation = !!r, this.isControllingVariants = tn(n), this.isVariantNode = bi(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: c, ...f } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const d in f) {
      const y = f[d];
      l[d] !== void 0 && P(y) && y.set(l[d], !1);
    }
  }
  mount(e) {
    this.current = e, ht.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, s) => this.bindToMotionValue(s, n)), ln.current || Oi(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Me.current, process.env.NODE_ENV !== "production" && Pe(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    ht.delete(this.current), this.projection && this.projection.unmount(), ve(this.notifyUpdate), ve(this.render), this.valueSubscriptions.forEach((e) => e()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const e in this.events)
      this.events[e].clear();
    for (const e in this.features) {
      const n = this.features[e];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(e, n) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const s = L.has(e), i = n.on("change", (a) => {
      this.latestValues[e] = a, this.props.onUpdate && O.preRender(this.notifyUpdate), s && this.projection && (this.projection.isTransformDirty = !0);
    }), r = n.on("renderRequest", this.scheduleRender);
    let o;
    window.MotionCheckAppearSync && (o = window.MotionCheckAppearSync(this, e, n)), this.valueSubscriptions.set(e, () => {
      i(), r(), o && o(), n.owner && n.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in Ae) {
      const n = Ae[e];
      if (!n)
        continue;
      const { isEnabled: s, Feature: i } = n;
      if (!this.features[e] && i && s(this.props) && (this.features[e] = new i(this)), this.features[e]) {
        const r = this.features[e];
        r.isMounted ? r.update() : (r.mount(), r.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : en();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let s = 0; s < pt.length; s++) {
      const i = pt[s];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const r = "on" + i, o = e[r];
      o && (this.propEventSubscriptions[i] = this.on(i, o));
    }
    this.prevMotionValues = Ei(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(e), () => n.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, n) {
    const s = this.values.get(e);
    n !== s && (s && this.removeValue(e), this.bindToMotionValue(e, n), this.values.set(e, n), this.latestValues[e] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let s = this.values.get(e);
    return s === void 0 && n !== void 0 && (s = oe(n === null ? void 0 : n, { owner: this }), this.addValue(e, s)), s;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, n) {
    var s;
    let i = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : (s = this.getBaseTargetFromProps(this.props, e)) !== null && s !== void 0 ? s : this.readValueFromInstance(this.current, e, this.options);
    return i != null && (typeof i == "string" && (Ot(i) || Rt(i)) ? i = parseFloat(i) : !Ni(i) && z.test(n) && (i = jt(e, n)), this.setBaseTarget(e, P(i) ? i.get() : i)), P(i) ? i.get() : i;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var n;
    const { initial: s } = this.props;
    let i;
    if (typeof s == "string" || typeof s == "object") {
      const o = mt(this.props, s, (n = this.presenceContext) === null || n === void 0 ? void 0 : n.custom);
      o && (i = o[e]);
    }
    if (s && i !== void 0)
      return i;
    const r = this.getBaseTargetFromProps(this.props, e);
    return r !== void 0 && !P(r) ? r : this.initialValues[e] !== void 0 && i === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new wt()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
}
class un extends Bi {
  constructor() {
    super(...arguments), this.KeyframeResolver = zt;
  }
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    return e.style ? e.style[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: s }) {
    delete n[e], delete s[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    P(e) && (this.childSubscription = e.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function Ki(t) {
  return window.getComputedStyle(t);
}
class zi extends un {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = nn;
  }
  readValueFromInstance(e, n) {
    if (L.has(n)) {
      const s = Le(n);
      return s && s.default || 0;
    } else {
      const s = Ki(e), i = (It(n) ? s.getPropertyValue(n) : s[n]) || 0;
      return typeof i == "string" ? i.trim() : i;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return gi(e, n);
  }
  build(e, n, s) {
    an(e, n, s.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n, s) {
    return rn(e, n, s);
  }
}
class qi extends un {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = en;
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (L.has(n)) {
      const s = Le(n);
      return s && s.default || 0;
    }
    return n = sn.has(n) ? n : Oe(n), e.getAttribute(n);
  }
  scrapeMotionValuesFromProps(e, n, s) {
    return wi(e, n, s);
  }
  build(e, n, s) {
    Di(e, n, this.isSVGTag, s.transformTemplate);
  }
  renderInstance(e, n, s, i) {
    Ti(e, n, s, i);
  }
  mount(e) {
    this.isSVGTag = Ri(e.tagName), super.mount(e);
  }
}
export {
  qe as $,
  fn as A,
  dn as B,
  mn as C,
  An as D,
  $i as E,
  O as F,
  bn as G,
  zi as H,
  $e as I,
  vi as J,
  Bn as K,
  tn as L,
  Ae as M,
  Z as N,
  bi as O,
  mt as P,
  wi as Q,
  Di as R,
  qi as S,
  Ri as T,
  Ti as U,
  Bi as V,
  rn as W,
  Vi as X,
  an as Y,
  ve as Z,
  js as _,
  I as a,
  re as a0,
  Ui as a1,
  Vt as a2,
  oe as b,
  yt as c,
  di as d,
  Us as e,
  fe as f,
  Cn as g,
  qs as h,
  P as i,
  De as j,
  zs as k,
  U as l,
  ge as m,
  en as n,
  Gi as o,
  Fe as p,
  Zt as q,
  Li as r,
  R as s,
  lt as t,
  ji as u,
  ht as v,
  Pe as w,
  pn as x,
  hn as y,
  gn as z
};
